// CSS Modules - component class name prefix: ProductDetailTabs__

<template>
  <div
    :class="[
      $style.container,
      { ProductDetailTabs__shopContainer: isShop === true }
    ]"
  >
    <div :class="$style.anchor" id="tabs"></div>
    <div v-if="!isMobile" :class="$style.tabs">
      <a
        v-for="(tab, index) in config.length"
        :key="`${index}-aKey`"
        v-on:click="updateTabs(tab)"
        :class="[
          $style.tab,
          { ProductDetailTabs__active: activeTab === tab },
          { ProductDetailTabs__disabled: config[index].disabled }
        ]"
        >{{ config[index].title }}</a
      >
      <div
        :class="[
          $style.content,
          { ProductDetailTabs__activeContent: activeTab === tab }
        ]"
        v-for="(tab, index) in config.length"
        :key="`${index}-bKey`"
      >
        <div
          v-if="contentLoaded === false && !config[index].isConfigurator"
          :class="$style.preloadFilter"
        ></div>
        <div
          v-if="
            activeTab === tab &&
              !config[index].isDownload &&
              !config[index].isTable &&
              !config[index].isConfigurator &&
              contentLoaded
          "
          v-html="content"
        ></div>
        <ProductDownloadsSection
          v-if="activeTab === tab && config[index].isDownload && contentLoaded"
          :initialSelectOption="config[index].initialSelectOption"
          :selectAllOption="config[index].selectAllOption"
          :downloads="content.downloads"
          :config="sectionConfig"
        />
        <Configurator
          v-if="activeTab === tab && config[index].isConfigurator"
          :config="config[index].configurator"
          :shopConfig="shopConfig"
        />
        <div v-if="config[index].isTable" class="ProductTable__container">
          <div v-if="activeTab === tab && contentLoaded" v-html="content"></div>
        </div>
        <section
          v-if="
            activeTab === 1 &&
              config[index].sliders &&
              config[index].sliders.length > 0
          "
          :class="$style.sliderSection"
        >
          <ProductSlider
            v-for="(slider, index) in config[index].sliders"
            :key="`${index}-sKey`"
            :config="slider"
          />
        </section>
      </div>
    </div>
    <div v-if="isMobile" :class="[$style.tabs, $style.mobile]">
      <div v-for="(tab, index) in config.length" :key="`${index}-cKey`">
        <a
          v-on:click="updateTabs(tab)"
          :class="[
            $style.tab,
            {
              ProductDetailTabs__active:
                activeTab === tab && mobileHidden !== tab
            },
            {
              ProductDetailTabs__configurator: config[index].isConfigurator
            },
            { ProductDetailTabs__disabled: config[index].disabled }
          ]"
          >{{ config[index].title }}</a
        >
        <div
          :class="[
            $style.content,
            {
              ProductDetailTabs__activeContent: activeTab === tab && !isMobile
            },
            {
              ProductDetailTabs__activeContent:
                activeTab === tab && isMobile && mobileHidden !== tab
            }
          ]"
        >
          <div
            v-if="contentLoaded === false && !config[index].isConfigurator"
            :class="$style.preloadFilter"
          ></div>
          <div
            v-if="
              activeTab === tab &&
                !config[index].isDownload &&
                !config[index].isTable &&
                !config[index].isConfigurator &&
                contentLoaded
            "
            v-html="content"
          ></div>
          <ProductDownloadsSection
            v-if="
              activeTab === tab && config[index].isDownload && contentLoaded
            "
            :initialSelectOption="config[index].initialSelectOption"
            :selectAllOption="config[index].selectAllOption"
            :downloads="content.downloads"
            :config="sectionConfig"
          />
          <Configurator
            v-if="activeTab === tab && config[index].isConfigurator"
            :config="config[index].configurator"
            :shopConfig="shopConfig"
          />
          <div v-if="config[index].isTable" class="ProductTable__container">
            <div
              v-if="activeTab === tab && contentLoaded"
              v-html="content"
            ></div>
          </div>
          <section
            v-if="
              activeTab === 1 &&
                config[0].sliders &&
                config[0].sliders.length > 0
            "
            :class="$style.sliderSection"
          >
            <ProductSlider
              v-for="(slider, index) in config[0].sliders"
              :key="`${index}-sKey`"
              :config="slider"
            />
          </section>
        </div>
      </div>
    </div>
    <Modal
      v-if="isShop"
      :class="$style.shopModal"
      :isModalOpen="isModalOpen"
      @closeModal="closeShopModal"
    >
      <div :class="$style.modal">
        <p :class="$style.heading">
          {{ shopConfig.inputPlaceholder }}: {{ articleNumber }}
        </p>
        <div class="columns">
          <div class="column is-two-thirds-tablet">
            <p :class="$style.subHeading">{{ shopConfig.articleDetails }}</p>
            <a
              v-if="dataSheetUrl && shopConfig.showDatasheetLink"
              :class="$style.docLink"
              @click="getDataSheet"
            >
              <template v-if="!isDataSheetLoading">
                {{ shopConfig.dataSheetText }}
              </template>
              <template v-else>
                <span>{{ shopConfig.dataSheetLoadingText }}</span>
                <i class="fas fa-spinner fa-spin"></i>
              </template>
            </a>
            <p v-html="data.longtext"></p>
          </div>
          <div class="column is-one-third-tablet">
            <div :class="$style.addToCart">
              <div class="columns is-mobile">
                <div :class="[$style.label, 'column']">
                  {{ shopConfig.pricePerItem }}:
                </div>
                <div :class="[$style.label, 'column']">{{ price }}</div>
              </div>
              <div :class="['columns', 'is-mobile', $style.countSum]">
                <div :class="[$style.label, 'column']">
                  {{ shopConfig.quantity }}:
                </div>
                <FormSelect
                  :hasFilter="false"
                  v-model="quantity"
                  :options="selectOptions"
                  :initialOption="quantity"
                  @input="priceSum"
                />
              </div>
              <hr />
              <div :class="$style.sum">{{ totalPrice }}</div>
              <div :class="$style.tax">
                {{ shopConfig.tax }} &amp;
                <a :href="shopConfig.shippingUrl">{{
                  shopConfig.shippingText
                }}</a>
              </div>
              <div
                v-if="data.deliveryCategory === 1"
                :class="$style.deliveryStatusGreen"
              >
                <span :class="$style.deliveryStatus"></span>
                {{ shopConfig.readyForShipping }}
              </div>
              <div
                v-if="data.deliveryCategory > 1"
                :class="$style.deliveryStatusOrange"
              >
                <span :class="$style.deliveryStatus"></span>
                {{ shopConfig.delivery }}: {{ deliveryDate }}
              </div>
              <div
                :class="[
                  $style.buttons,
                  { ProductDetailTabs__buttonsHidden: addingToCart }
                ]"
              >
                <ShopCartLink
                  :key="`cartLink-${componentKey}`"
                  :item="{
                    text: shopConfig.addButtonText,
                    quantity: quantity,
                    id: articleNumber,
                    headline: shopConfig.headline,
                    subheadline: shopConfig.subheadline,
                    pictureurl: shopConfig.pictureurl,
                    thumbnailurl: shopConfig.thumbnailurl,
                    producturl: shopConfig.producturl
                  }"
                  :addItemFailedMsg="shopConfig.addArticleFailedMessage"
                  :addButtonLoadingText="shopConfig.addButtonLoadingText"
                  @closed="addToCart"
                />
                <div
                  :class="[
                    $style.loadingBasket,
                    { ProductDetailTabs__loadingBasketVisible: addingToCart }
                  ]"
                >
                  <img :src="loadingGif" />
                  {{ shopConfig.addButtonLoadingText }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import axios from "axios";
import Modal from "../Modal/Modal.vue";
import {
  createDataSheetUrl,
  sessionLoginUrl,
  sessionLogoutUrl
} from "../../shared/globals";
import FormSelect from "../FormSelect/FormSelect.vue";
import ProductSlider from "../ProductSlider/ProductSlider.vue";
import ProductDownloadsSection from "../ProductDownloadsSection/ProductDownloadsSection.vue";
import ShopCartLink from "../ShopCartLink/ShopCartLink";
import LoadingGif from "../../assets/loading.gif";
import { b64toBlob } from "../../utils/convertData";
import { sortCollectionInGivenArray } from "../../utils/sort";
import Configurator from "../Configurator/Configurator.vue";
import * as Storage from "../../shared/Storage";
import StorageKeys from "../../globals/constants/storageKeys";
import CustomEvents from "../../globals/constants/customEvents";
import getDeliveryDateFromUrl from "../../xhr/product/getDeliveryDateFromUrl";
import {
  convertISODateTimeToISODate,
  convertISODateTimeToLocaleDate
} from "../../utils/dateTime";

export default {
  name: "ProductDetailTabs",
  components: {
    Modal,
    FormSelect,
    ProductSlider,
    ProductDownloadsSection,
    ShopCartLink,
    Configurator
  },
  props: {
    config: {
      type: Array,
      default: () => []
    },
    shopConfig: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      componentKey: 0,
      isShop: false,
      isMobile: false,
      activeTab: 1,
      mobileHidden: null,
      content: null,
      contentLoaded: false,
      scrollWarning: "",
      tableTabIsActive: false,
      detailLinkText: "",
      RFQText: "",
      RFQUrl: "",
      productTypes: "",
      shopLinkText: "",
      currentUrl: [],
      isModalOpen: false,
      articleNumber: null,
      quantity: "1",
      data: {},
      price: null,
      totalPrice: null,
      deliveryCategory: "",
      deliveryDate: null,
      addingToCart: false,
      isDataSheetLoading: false,
      loadingGif: LoadingGif,
      activeTabPreselected: false,
      sectionConfig: {},
      emTable: null,
      radios: null,
      techInfo: null,
      firstTableLoad: true,
      currentTableID: null,
      dataSheetUrl: null,
      articleData: null
    };
  },
  computed: {
    selectOptions: function() {
      const range = (start, end) =>
        [...Array(end - start + 1)].map((_, i) => start + i).map(String);
      return range(1, this.shopConfig.selectOptionMax);
    }
  },
  methods: {
    forceRerender() {
      this.componentKey += 1;
    },
    checkScreenSize() {
      const currentState = this.isMobile;
      window.innerWidth < 780
        ? (this.isMobile = true)
        : (this.isMobile = false);
      if (currentState !== this.isMobile && this.tableTabIsActive) {
        this.initProductTable();
      }
    },
    initContent() {
      this.contentLoaded = true;
    },
    initTableContent() {
      this.tableTabIsActive = true;
      const index = this.activeTab - 1;
      this.scrollWarning = this.config[index].scrollWarning;
      this.detailLinkText = this.config[index].detailLinkText;
      this.RFQText = this.config[index].RFQText;
      this.RFQUrl = this.config[index].RFQUrl;
      this.productTypes = this.config[index].productTypes;
      this.shopLinkText = this.config[index].shopLinkText;
      this.shopUrl = this.config[index].shopUrl;
      this.initProductTable();
    },
    initTabs() {
      const queries = window.location.search.substring(1).split("&");
      let queryStringTabId = null;
      if (queries) {
        for (const query of queries) {
          if (query.includes("tab")) {
            queryStringTabId = query.split("=")[1];
          }
        }
      }
      if (queryStringTabId) {
        for (const [index, tab] of this.config.entries()) {
          if (tab.id && queryStringTabId === tab.id && !tab.disabled) {
            this.activeTab = index + 1;
            this.activeTabPreselected = true;
            if (tab.url) {
              this.currentUrl = tab.url;
              this.getContentFromUrl(tab.url);
            } else {
              this.getContentFromId(tab.id);
            }
          }
        }
      } else {
        for (const [index, tab] of this.config.entries()) {
          if (tab.active && !tab.disabled) {
            this.activeTab = index + 1;
            this.activeTabPreselected = true;
            if (tab.url) {
              this.currentUrl = tab.url;
              this.getContentFromUrl(tab.url);
            } else if (tab.id) {
              this.getContentFromId(tab.id);
            }
          }
        }
      }
      if (!this.activeTabPreselected) {
        const firstNotDisabledTabIndex = this.config.findIndex(
          tab => !tab.disabled
        );
        this.activeTab = firstNotDisabledTabIndex + 1;
        this.contentLoaded = false;
        if (this.config[firstNotDisabledTabIndex].url) {
          this.currentUrl = this.config[firstNotDisabledTabIndex].url;
          this.getContentFromUrl(this.config[firstNotDisabledTabIndex].url);
        } else if (this.config[firstNotDisabledTabIndex].id) {
          this.getContentFromId(this.config[firstNotDisabledTabIndex].id);
        } else {
          this.contentLoaded = true;
        }
      }
    },
    updateTabs(tab) {
      const elm = event.currentTarget;
      if (!elm.classList.contains("ProductDetailTabs__disabled")) {
        this.updateTabContent(tab);
      }
    },
    updateTabsFromLink(tabID) {
      for (let i = 0; i < this.config.length; i++) {
        if (this.config[i].tabID === tabID && !this.config[i].disabled) {
          this.updateTabContent(i + 1);
        }
      }
    },
    updateTabContent(tab) {
      this.contentLoaded = false;
      if (
        this.isMobile &&
        this.activeTab === tab &&
        this.activeTab !== this.mobileHidden
      ) {
        this.mobileHidden = tab;
      } else if (
        this.isMobile &&
        this.activeTab === tab &&
        this.activeTab === this.mobileHidden
      ) {
        this.mobileHidden = null;
      } else if (this.isMobile && this.activeTab !== tab) {
        this.mobileHidden = null;
        this.activeTab = tab;
      } else {
        this.activeTab = tab;
      }
      if (this.config[tab - 1].url) {
        this.currentUrl = this.config[tab - 1].url;
        this.getContentFromUrl(this.currentUrl);
        if (!this.config[tab - 1].isTable) {
          this.tableTabIsActive = false;
          if (this.config[tab - 1].isDownload) {
            this.sectionConfig = this.config[tab - 1];
          }
        }
      } else if (this.config[tab - 1].id) {
        this.tableTabIsActive = false;
        this.getContentFromId(this.config[tab - 1].id);
      } else {
        this.tableTabIsActive = false;
        this.content = null;
      }
    },
    getContentFromId(id) {
      const html = document.getElementById(id);
      if (html) {
        this.content = html.innerHTML;
        this.contentLoaded = true;
      } else {
        this.content = null;
        this.contentLoaded = false;
      }
    },
    mergeData(responses) {
      let mergedData = {};
      for (const response of responses.map(x => x.data)) {
        if (response.downloads) {
          // Check if element contains projectdocuments, approvals or declarations
          if (Array.isArray(response.downloads)) {
            mergedData.downloads = response.downloads;
          } else {
            if (
              response.downloads.approvals &&
              response.downloads.approvals.files.length > 0
            ) {
              const approvals = response.downloads.approvals;
              approvals.viewType = "approvals";
              approvals.label =
                this.sectionConfig.labels && this.sectionConfig.labels.approvals
                  ? this.sectionConfig.labels.approvals
                  : "approvals";
              mergedData.downloads.push(approvals);
            } else if (
              response.downloads.projectdocuments &&
              response.downloads.projectdocuments.files.length > 0
            ) {
              const projectdocuments = response.downloads.projectdocuments;
              projectdocuments.viewType = "projectdocuments";
              projectdocuments.label =
                this.sectionConfig.labels &&
                this.sectionConfig.labels.projectdocuments
                  ? this.sectionConfig.labels.projectdocuments
                  : "projectdocuments";
              mergedData.downloads.push(projectdocuments);
            } else if (
              response.downloads.declarations &&
              response.downloads.declarations.files.length > 0
            ) {
              const declarations = response.downloads.declarations;
              declarations.viewType = "declarations";
              declarations.label =
                this.sectionConfig.labels &&
                this.sectionConfig.labels.declarations
                  ? this.sectionConfig.labels.declarations
                  : "declarations";
              mergedData.downloads.push(declarations);
            }
          }
        }
      }
      return mergedData;
    },
    getContentFromUrl(urls) {
      const isDownload = this.config[this.activeTab - 1].isDownload || false;
      const isTable = this.config[this.activeTab - 1].isTable || false;

      axios
        .all([...urls].map(x => axios.get(x)))
        .then(response => {
          if (isDownload) {
            this.content = this.mergeData(response);
            this.content.downloads = sortCollectionInGivenArray(
              [...this.content.downloads],
              "asc",
              "sortValue"
            );
          } else {
            this.content = response[0].data;

            if (isTable) {
              this.initTableContent();
            }
          }
          this.initContent();
        })
        .catch(
          error => (
            console.error(error),
            (this.content = null),
            (this.contentLoaded = false)
          )
        );
    },
    updateContentFromUrl(urls) {
      const isDownload = this.config[this.activeTab - 1].isDownload || false;
      axios
        .all([...urls].map(x => axios.get(x)))
        .then(response => {
          if (isDownload) {
            this.content = this.mergeData(response);
            sortCollectionInGivenArray(
              [...this.content.downloads],
              "asc",
              "sortValue"
            );
          } else {
            this.content = response[0].data;
          }
          this.contentLoaded = true;
        })
        .catch(
          error => (
            console.error(error),
            (this.content = null),
            (this.contentLoaded = false)
          )
        );
    },
    getNewTable(url, id) {
      this.currentTableID = id;
      if (this.currentUrl[0] !== url) {
        const urls = [url];
        this.currentUrl = urls;
        this.contentLoaded = false;
        this.updateContentFromUrl(urls);
        this.initProductTable();
      } else if (this.firstTableLoad && this.techInfo) {
        this.emTable.style.display = "block";
        this.techInfo.style.display = "block";
        this.emTableCreate(this.emTable);
        this.firstTableLoad = false;
      }
    },
    initProductTable() {
      const vueElement = this;
      setTimeout(() => {
        if (this.contentLoaded === false) {
          this.initProductTable();
        } else {
          this.emTable = document.querySelector(".em-table-slide");
          this.radios = document.querySelector(".ProductTable__radios");
          this.techInfo = document.querySelector(".ProductTable__techInfo");
          if (this.radios) {
            $(".orderDataItem").one("change", function() {
              vueElement.emTable.style.display = "none";
              vueElement.getNewTable($(this).val(), $(this).attr("id"));
            });
            if (this.firstTableLoad) {
              this.emTable.style.display = "none";
            } else if (this.techInfo) {
              this.techInfo.style.display = "block";
              this.emTableCreate(this.emTable);
              document.getElementById(this.currentTableID).checked = true;
            }
          } else if (this.techInfo) {
            this.techInfo.style.display = "block";
            this.emTableCreate(this.emTable);
          }
        }
      }, 200);
    },
    emTableCreate(element) {
      if (element) {
        var $this = $(element),
          uniqueID = "";

        if (window.instance !== "shop") {
          $(".em-table-legend-shop").hide();
          if (
            !window.shopAvailable ||
            (window.shopAvailable && !window.isShopPageAvailable)
          ) {
            $(".em-table-legend")
              .children(".not-online")
              .hide();
          } else {
            $(".em-table-legend")
              .children("li")
              .addClass("shopview");
            $(".em-table-legend")
              .children("li")
              .children("span")
              .addClass("shopview");
          }
        } else {
          $(".em-table-legend").hide();
        }

        var listLength = $this
          .find("tbody > tr:not(.seperator):first")
          .children("td:not(.fixed-col)").length;

        //wrap table
        const vueElement = this;
        $this.each(function() {
          var nav = "";
          var maxListLength = window.instance === "shop" ? 8 : 6;
          var $table = $(this);

          if ($table.attr("data-init") == 1) {
            return;
          }

          //create unique ID
          var id = function() {
            return Math.random()
              .toString(36)
              .substr(2, 9);
          };

          uniqueID = id();

          //create navigation
          nav += '<div class="button-navigation" data-ID="' + uniqueID + '">';
          nav += '<span class="Button__button Button__orange prev disabled">';
          nav += '<a class="arrow">Previous</a>';
          nav += "</span>";
          nav += '<span class="Button__button Button__orange next">';
          nav += '<a class="arrow">Next</a>';
          nav += "</span>";
          nav += "</div>";

          //add id to filter
          $table
            .closest("#tabContent")
            .find(".productFilter")
            .attr("data-id", uniqueID);

          //append navigation and minimap
          if (listLength > maxListLength) {
            $(".productFilter[data-ID=" + uniqueID + "]").append(nav);
          } else {
            vueElement.calcColWidth($table);
            if (window.instance !== "shop") {
              $(".productFilter.orderData").hide();
            }
          }

          //append table wrap
          $table
            .wrap(
              '<div class="em-table-outer-wrap"><div class="em-table-inner-wrap"></div></div>'
            )
            .attr("id", uniqueID);
          $table.attr("data-init", 1);
          $table
            .parent()
            .parent()
            .before(
              `<div class='mobile-scroll-warning'>${
                vueElement.scrollWarning
              }</div>`
            );
        });

        //set height for row of a fixed column cell
        vueElement.calcColHeight();

        if (window.instance !== "shop" && !window.shopAvailable) {
          $(".em-table-legend .not-online").hide();
        } else if (window.instance === "shop" || window.shopAvailable) {
          //remove hyperlink and change class in cells with deliveryCategory above 2 when in shop
          $this
            .find("tbody")
            .find("input:hidden")
            .each(function() {
              var $this = $(this)[0];
              if (
                $this.id.indexOf("DeliveryCategory") > -1 &&
                disallowedDCs.indexOf(parseInt($this.value)) > -1
              ) {
                $($this.parentElement)
                  .removeClass("after-production")
                  .removeClass("in-stock")
                  .addClass("not-online");
                //Only remove tooltip listner if we inside the shop. Website should show longtext information as well for all articles not online available
                if (window.instance === "shop") {
                  $this.parentElement.innerHTML = $this.id.replace(
                    "DeliveryCategory_",
                    ""
                  );
                }
              }
            });
        }
        if (window.instance !== "shop") {
          this.createTooltips();
        }
        this.setupEvents();
        setTimeout(() => {
          document.querySelector(".em-table-slide").style.opacity = 1;
          document.querySelector(".em-table-slide").style.display = "block";
          document.querySelector(".productFilter").style.opacity = 1;
        }, 500);
      }
    },
    checkLocalStorage() {
      this.articleData = Storage.getLocalStorage(
        StorageKeys.ARTICLE_DATA,
        true
      );
      if (!this.articleData) {
        this.articleData = [];
        Storage.setLocalStorage(
          StorageKeys.ARTICLE_DATA,
          this.articleData,
          true
        );
      }
    },
    sendDataToRFQForm(eventDetail) {
      const regexBreak = /\n/g;
      let article = "";
      let detailText = "";
      if (eventDetail.id) {
        article = eventDetail.id.toString();
        detailText = eventDetail.detailText;
      } else {
        article = eventDetail.toString();
        detailText = document.getElementById(`${article}`).value;
      }

      detailText =
        detailText && regexBreak.test(detailText)
          ? detailText.replace(regexBreak, "<br />")
          : detailText;

      if (this.articleData.length === 0) {
        this.articleData = [
          {
            productTypes: this.productTypes,
            articles: [{ number: article, total: "1", detailText: detailText }]
          }
        ];
      } else {
        for (const item of this.articleData) {
          if (item.productTypes.includes(this.productTypes)) {
            for (const numberObject of item.articles) {
              if (numberObject.number === article) {
                window.location = this.RFQUrl;
                return;
              }
            }
            item.articles.push({
              number: article,
              total: "1",
              detailText: detailText
            });
            Storage.setLocalStorage(
              StorageKeys.ARTICLE_DATA,
              this.articleData,
              true
            );
            window.location = this.RFQUrl;
            return;
          }
        }
        this.articleData.push({
          productTypes: this.productTypes,
          articles: [{ number: article, total: "1", detailText: detailText }]
        });
      }
      Storage.setLocalStorage(StorageKeys.ARTICLE_DATA, this.articleData, true);
      window.location = this.RFQUrl;
    },
    createTooltips() {
      const detailLinkText = this.detailLinkText;
      const RFQText = this.RFQText;
      const shopLinkText = this.shopLinkText;
      const shopUrl = this.shopUrl;
      const allTooltips = $(".tooltip-listener").parent();

      $(allTooltips).each(function() {
        const tipListener = this.querySelector(".tooltip-listener");
        const modalContent = $(tipListener)
          .next()
          .val();
        const deliveryCategory = $(this)
          .find("input:hidden[id*='DeliveryCategory_']")
          .val();
        let tip = "";
        if (
          window.shopAvailable &&
          window.isShopPageAvailable &&
          deliveryCategory > 0 &&
          deliveryCategory < 3
        ) {
          tip = `
            <ul class="DownloadBox__downloadLinks">
              <li>
                <a
                  class="showProductInfo"
                  data-itemid="${tipListener.innerHTML}"
                  onclick="
                    event.preventDefault();
                    event.stopPropagation();
                    document.querySelector('html').classList.add('is-clipped');
                    event.currentTarget.closest('td').firstElementChild.querySelector('.modal').classList.add('is-active');"
                >
                  <i class="fas fa-file-alt"></i>${detailLinkText}
                </a>
              </li>
              <li>
                <a
                  class="requestForQuotation"
                  data-itemid="${tipListener.innerHTML}"
                  onclick="
                    event.preventDefault();
                    event.stopPropagation();
                    window.dispatchEvent(new CustomEvent('addToLocalStorage', {detail: ${
                      tipListener.innerHTML
                    }}));"
                >
                  <i class="fas fa-file-medical"></i>${RFQText}
                </a>
              </li>
              <li>
                <a
                  class="toShopPage"
                  data-itemid="${tipListener.innerHTML}"
                  target="_blank"
                  href="${shopUrl}${tipListener.innerHTML}"
                >
                  <i class="fas fa-shopping-cart"></i>${shopLinkText}
                </a>
              </li>
            </ul>
          `;
        } else {
          tip = `
            <ul class="DownloadBox__downloadLinks">
              <li>
                <a
                  class="showProductInfo"
                  data-itemid="${tipListener.innerHTML}"
                  onclick="
                    event.preventDefault();
                    event.stopPropagation();
                    document.querySelector('html').classList.add('is-clipped');
                    event.currentTarget.closest('td').firstElementChild.querySelector('.modal').classList.add('is-active');"
                >
                  <i class="fas fa-file-alt"></i>${detailLinkText}
                </a>
              </li>
              <li>
                <a
                  class="requestForQuotation"
                  data-itemid="${tipListener.innerHTML}"
                  onclick="
                    event.preventDefault();
                    event.stopPropagation();
                    window.dispatchEvent(new CustomEvent('addToLocalStorage', {detail: ${
                      tipListener.innerHTML
                    }}));"
                >
                  <i class="fas fa-file-medical"></i>${RFQText}
                </a>
              </li>
            </ul>
          `;
        }
        const modal = `
          <div class="Modal__container modal" id="modal${
            tipListener.innerHTML
          }">
            <div
              class="modal-background"
              onclick="
                event.preventDefault();
                event.stopPropagation();
                document.querySelector('html').classList.remove('is-clipped');
                document.querySelector('.em-table-inner-wrap').style.overflowX = null;
                document.querySelector('.modal.is-active').classList.remove('is-active');
              "
            ></div>
            <div class="modal-content">
              <div class="Modal__content">
                <div class="Modal__title">${detailLinkText}</div>
                ${modalContent}
              </div>
            </div>
            <button
              class="modal-close is-large"
              aria-label="close"
              onclick="
                event.preventDefault();
                event.stopPropagation();
                document.querySelector('html').classList.remove('is-clipped');
                document.querySelector('.em-table-inner-wrap').style.overflowX = null;
                document.querySelector('.modal.is-active').classList.remove('is-active');
              "
            ></button>
          </div>
        `;
        $(tipListener).append(modal);
        tippy(tipListener, {
          theme: "wika light tooltip",
          interactive: true,
          placement: "top",
          flip: false,
          arrow: true,
          distance: 0,
          zIndex: 10000,
          content: tip
        });
      });
    },
    closeModal() {
      document.querySelector(".modal.is-active").classList.remove("is-active");
    },
    closeShopModal() {
      if (window.instance === "shop") {
        this.dataSheetUrl = window.createDataSheetUrl || createDataSheetUrl;
      }
      this.isModalOpen = false;
    },
    escCloseModal(event) {
      if (event.keyCode === 27) {
        window.instance === "shop" ? this.closeShopModal() : this.closeModal();
      }
    },
    addToCart() {
      this.addingToCart = true;
      setTimeout(() => {
        this.addingToCart = false;
        this.closeShopModal();
      }, 1000);
    },
    calcColWidth(element) {
      var children = element
        .find("tbody")
        .find('tr:not(".seperator")')
        .first()
        .children('td:not(".fixed-col")');

      var tableWidth =
        window.instance === "shop" ? 780 : Math.max(element.width() - 173, 540); // if you change this also take a look in ProductDetailTabs.scss
      var newColWidth = tableWidth / children.length - 21;

      children.css({ minWidth: newColWidth, maxWidth: newColWidth });
    },
    calcColHeight() {
      var fixed = false;

      $(".fixed-col")
        .not(".rowspan")
        .each(function() {
          var $this = $(this),
            colHeightTh = $this.height(),
            colHeightTd = $this.next().height();
          if (colHeightTh > colHeightTd) {
            $this
              .siblings()
              .not(".rowspan")
              .height(colHeightTh);
            $this.height(colHeightTh);
          } else {
            $this
              .siblings()
              .not(".rowspan")
              .height(colHeightTd);
            $this.height(colHeightTd);
          }
        });

      var equalTDHeight = function(max) {
        if (fixed) {
          return false;
        }
        //use the same element everywhere
        var tbodyrows = $("tr.seperator")
            .parent()
            .find(".fixed-col")
            .not(".rowspan"),
          setHeight = function(h) {
            tbodyrows.each(function() {
              var $this = $(this);
              $this
                .siblings()
                .not(".rowspan")
                .height(h);
              $this.height(h);
            });
          },
          highest = 0;

        if (max) {
          return setHeight(max);
        }
        tbodyrows.not(".init").each(function() {
          $(this)
            .siblings()
            .each(function() {
              var $this = $(this),
                h = $this.height();
              if (h > highest) {
                highest = h;
              }
            });
        });
        setHeight(highest);
      };
      //equal height
      equalTDHeight();

      // left col
      $(".fixed-col.rowspan")
        .not(".init")
        .each(function() {
          var el = $(this),
            //span = el.find('span'),
            maxheight = 270,
            rows = $("tr.seperator")
              .parent()
              .find(".fixed-col")
              .not(".rowspan")
              .not(".init").length,
            height = el.parents("tbody").height();
          // check minheight, eventually adjust height
          if (height <= maxheight) {
            height = maxheight;
          }
          //set height and position
          el.addClass("init").height(height - 11);
          //correct td heights
          if (height <= maxheight) {
            equalTDHeight($(".init").outerHeight() / rows);
          }
          //correct rounding errors, due to outerHeight() and height() usage
          $(".init").outerHeight(
            $("tr.seperator")
              .parent()
              .height()
          );
          fixed = true;
        });
    },
    setupEvents() {
      const vueElement = this;
      $(".button-navigation")
        .find(".Button__button")
        .on("click", function() {
          vueElement.emTableSlide($(this));
          return false;
        });
      if (window.instance === "shop") {
        $(".after-production").on("click", function(event) {
          event.preventDefault();
          event.stopPropagation();
          vueElement.displayShopModal(event.currentTarget);
        });
        $(".in-stock").on("click", function(event) {
          event.preventDefault();
          event.stopPropagation();
          vueElement.displayShopModal(event.currentTarget);
        });
      }
    },
    emTableSlide(element) {
      var uniqueID = element.parent().attr("data-ID"),
        maxScroll =
          $("#" + uniqueID)
            .find("tbody")
            .width() -
          $("#" + uniqueID)
            .parents(".em-table-inner-wrap")
            .width(),
        scrollContainer = $("#" + uniqueID).parents(".em-table-inner-wrap");

      //scroll table
      const scrollWidth = $("#" + uniqueID).width();

      if (element.hasClass("prev")) {
        this.emTableScrollContainer(uniqueID, -scrollWidth);
      } else {
        this.emTableScrollContainer(uniqueID, scrollWidth);
      }

      //set disabled class for next button
      if (scrollContainer.scrollLeft() != maxScroll) {
        $(".button-navigation[data-ID=" + uniqueID + "]")
          .find(".next")
          .removeClass("disabled");
      } else {
        $(".button-navigation[data-ID=" + uniqueID + "]")
          .find(".next")
          .addClass("disabled");
      }

      //set disabled class for prev button
      if (scrollContainer.scrollLeft() != 0) {
        $(".button-navigation[data-ID=" + uniqueID + "]")
          .find(".prev")
          .removeClass("disabled");
      } else {
        $(".button-navigation[data-ID=" + uniqueID + "]")
          .find(".prev")
          .addClass("disabled");
      }
    },
    emTableScrollContainer(uniqueID, leftOffset) {
      var scrollContainer = $("#" + uniqueID).parents(".em-table-inner-wrap");
      const left = scrollContainer.scrollLeft() + leftOffset;
      scrollContainer.scrollLeft(left);
    },
    priceSum() {
      const totalPrice = (this.data.price * this.quantity)
        .toString()
        .replace(".", ",");
      this.totalPrice = accounting.formatMoney(
        parseFloat(totalPrice.replace(".", "").replace(",", ".")),
        {
          symbol: this.shopConfig.currency,
          format: this.shopConfig.currencyPosition,
          decimal: this.shopConfig.decimalSep,
          thousand: this.shopConfig.thousandSep,
          precision: this.shopConfig.precisionValue
        }
      );
      this.forceRerender();
    },
    getDeliveryDate() {
      const postData = {
        fromdate: convertISODateTimeToISODate(new Date().toISOString()),
        "ax-system": this.shopConfig.deliveryAxSystem,
        days: this.data.deliveryDays || 4
      };

      getDeliveryDateFromUrl(this.shopConfig.deliveryDateUrl, postData)
        .then(responseData => {
          const workingDate = convertISODateTimeToLocaleDate(
            responseData.result[0].workingDate,
            window.currentCountry
          );
          this.deliveryDate = workingDate;
        })
        .catch(error => console.error(error));
    },
    displayShopModal(modalData) {
      const shopData = modalData.querySelector(".articleinfo");
      this.articleNumber = shopData.id;
      this.data.longtext = shopData.value;
      this.data.deliveryDays = modalData
        .querySelector(`#DeliveryDays_${shopData.id}`)
        .value.split(";")[0];
      this.data.deliveryTime =
        parseInt(this.data.deliveryDays) +
        parseInt(this.shopConfig.externalTransport);
      this.data.deliveryCategory = parseInt(
        modalData
          .querySelector(`#DeliveryCategory_${shopData.id}`)
          .value.split(";")[0]
      );
      this.data.price = modalData
        .querySelector(`#Price_${shopData.id}`)
        .value.split(";")[0];
      this.price = this.data.price.toString().replace(".", ",");
      this.price = accounting.formatMoney(
        parseFloat(this.price.replace(".", "").replace(",", ".")),
        {
          symbol: this.shopConfig.currency,
          format: this.shopConfig.currencyPosition,
          decimal: this.shopConfig.decimalSep,
          thousand: this.shopConfig.thousandSep,
          precision: this.shopConfig.precisionValue
        }
      );
      this.getDeliveryDate();
      this.forceRerender();
      this.isModalOpen = true;
    },
    getDataSheet() {
      this.isDataSheetLoading = true;
      const currentLang = window.currentLanguage.toLowerCase();
      const sessionLoginUrlCompleted = `${window.sessionLoginUrl ||
        sessionLoginUrl}&lng=${currentLang}`;
      let sessionLogoutUrlCompleted = "";

      const logout = () => {
        axios({
          url: sessionLogoutUrlCompleted,
          method: "get",
          responseType: "json"
        })
          .then(logoutResponse => {
            if (logoutResponse.Status === "ERROR") {
              console.error(
                `Session logout failed: ${logoutResponse.ErrorText}`,
                logoutResponse
              );
            }
          })
          .catch(error => console.error("Session logout failed: ", error));
      };

      axios({
        url: sessionLoginUrlCompleted,
        method: "get",
        responseType: "json"
      })
        .then(response => {
          if (response.Status === "ERROR") {
            console.error(
              `Session login failed: ${response.ErrorText}`,
              response
            );
          } else {
            const dataSheetUrlComplete = `${
              this.dataSheetUrl
            }&lng=${currentLang}&session=${response.data.SessionId}&itemid=${
              this.articleNumber
            }`;
            sessionLogoutUrlCompleted = `${window.sessionLogoutUrl ||
              sessionLogoutUrl}&session=${
              response.data.SessionId
            }&lng=${currentLang}`;

            axios({
              url: dataSheetUrlComplete,
              method: "get",
              responseType: "json"
            })
              .then(dataSheetResponse => {
                if (dataSheetResponse.Status === "ERROR") {
                  logout();
                  console.error("Load data sheet fialed: ", dataSheetResponse);
                } else {
                  const docFormat =
                    dataSheetResponse.data.ItemBasedDataSheet.DocFormat;
                  const item = dataSheetResponse.data.ItemBasedDataSheet.Item;
                  const blob = b64toBlob(
                    dataSheetResponse.data.ItemBasedDataSheet.Data,
                    `application/${docFormat}`
                  );

                  const url = window.URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = `${
                    this.shopConfig.dataSheetText
                  }-${item}.${docFormat}`;
                  document.body.appendChild(a);
                  a.click();
                  a.remove();
                  this.isDataSheetLoading = false;
                  logout();
                }
              })
              .catch(error => {
                this.isDataSheetLoading = false;
                logout();
                console.error("Load data sheet fialed: ", error);
              });
          }
        })
        .catch(error => {
          this.isDataSheetLoading = false;
          console.error("Session login failed: ", error);
        });
    },
    pollyfillClosest() {
      if (!Element.prototype.matches) {
        Element.prototype.matches =
          Element.prototype.msMatchesSelector ||
          Element.prototype.webkitMatchesSelector;
      }

      if (!Element.prototype.closest) {
        Element.prototype.closest = function(s) {
          var el = this;

          do {
            if (Element.prototype.matches.call(el, s)) return el;
            el = el.parentElement || el.parentNode;
          } while (el !== null && el.nodeType === 1);
          return null;
        };
      }
    }
  },
  mounted() {
    if (window.instance === "shop") {
      this.isShop = true;
      this.dataSheetUrl = window.createDataSheetUrl || createDataSheetUrl;
    }
    this.pollyfillClosest();
    window.addEventListener("resize", this.checkScreenSize);
    window.addEventListener("keyup", this.escCloseModal);
    window.addEventListener("addToLocalStorage", event => {
      this.sendDataToRFQForm(event.detail);
    });
    window.addEventListener(CustomEvents.OPEN_TAB_FROM_LINK, event => {
      this.updateTabsFromLink(event.detail);
    });
    this.checkLocalStorage();
    this.checkScreenSize();
    this.initTabs();
  },
  destroyed() {
    window.removeEventListener("resize", this.checkScreenSize);
    window.removeEventListener("keyup", this.escCloseModal);
    window.removeEventListener("addToLocalStorage", event => {
      this.sendDataToRFQForm(event.detail);
    });
    window.removeEventListener(CustomEvents.OPEN_TAB_FROM_LINK, event => {
      this.updateTabsFromLink(event.detail);
    });
  }
};
</script>

<style module lang="scss">
@import "./ProductDetailTabs.scss";
</style>
